<div class="multi-select-pills" role="list">
  @for (item of items; track item.id) {
    <div
      class="multi-select-pills__pill"
      role="listitem"
      [matTooltip]="item.label"
      [matTooltipDisabled]="!item.label"
      matTooltipPosition="above"
    >
      <span class="multi-select-pills__label">{{ item.label }}</span>
      <button
        type="button"
        class="multi-select-pills__remove"
        [attr.aria-label]="'Remove ' + item.label"
        (click)="onRemove(item.id, $event)"
      >
        <mat-icon svgIcon="close" />
      </button>
    </div>
  }
</div>
